export const getDeliveryTypesSuccess = (deliveryTypes) => {
    return {
        type: "GET_DELIVERY_TYPES_SUCCESS",
        payload: deliveryTypes
    }
};
